import { createReducer } from '@reduxjs/toolkit'
import { arrayToObject } from 'helpers/Functions'

import { StatusBannerData } from 'utils/types'

import * as actions from '../../../actions/internal/StatusBanner/actions'
import * as authenticationActions from '../../../actions/Authentication/actions'

export interface StatusBannerReducerType {
  data: Record<string, StatusBannerData>
  fetched: boolean
}

const INITIAL_STATE: StatusBannerReducerType = {
  data: {},
  fetched: false
}

const StatusBannerReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = arrayToObject(action.payload.data) as Record<
        string,
        StatusBannerData
      >
      state.fetched = true
    })
    .addCase(actions.createSuccess, (state, action) => {
      state.data[action.payload.data.id] = action.payload.data
    })
    .addCase(actions.updateSuccess, (state, action) => {
      state.data[action.payload.data.id] = action.payload.data
    })
    .addCase(actions.destroySuccess, (state, action) => {
      delete state.data[action.payload.id]
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default StatusBannerReducer
